import './GridSystem.scss';

function GridSystem({ children }) {
    return children;
}

export default GridSystem;
